import React from 'react';
import {Provider} from 'react-redux';
import ReactOnRails from 'react-on-rails';
import {BrowserRouter} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import * as rubricsActions from '../actions/rubricsActionCreators';
import * as cartActions from '../actions/cartActionCreators';
import * as applicationActions from '../actions/applicationActionCreators';
import axios from 'axios';
import {useMount} from 'react-use';

const
  metaTag = document.querySelector('meta[name="csrf-token"]'),
  token = metaTag.content;
axios.defaults.headers.common['X-CSRF-Token'] = token;

const App = (props, _railsContext) => {
  const store = ReactOnRails.getStore('shopStore'),
    clearMeta = () => {
      const nodes = [
        ...document.querySelectorAll('meta[property]'),
        ...document.querySelectorAll('meta[name]:not(meta[name="csrf-token"])'),
        document.querySelectorAll('link[rel="canonical"]')?.[0]
      ];
      _.compact(nodes)?.forEach(node => typeof node?.remove === 'function' && node.remove());
    }
  
  return () => {
    useMount(() => {
      store.dispatch(rubricsActions.fetchRubricsTree());
      store.dispatch(cartActions.fetchCart());
      store.dispatch(applicationActions.fetchPageSettings());
      clearMeta();
    });
    return (
      <div>
        <Provider store={store}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </Provider>
      </div>
    )
  };
}

export default App;
